export class DataProtectionNoticeItemFileLoad {
  public static readonly type = '[DataProtectionNoticeItemFile] Load';

  constructor(public payload: string) {}
}

export class DataProtectionNoticeItemFileDownload {
  public static readonly type = '[DataProtectionNoticeItemFile] Download';

  constructor(public payload: { dpnFileId: string; version: string }) {}
}

export class DataProtectionNoticeLastItemFileLoad {
  public static readonly type = '[DataProtectionNoticeLastItemFile] Load';

  constructor(public country: string) {}
}

export class DataProtectionNoticeItemFileInitialState {
  public static readonly type = '[DataProtectionNoticeItemFile] Set Initial State';
}
